import React from "react";

import { useSelector } from "react-redux";
import { Route, Switch, useHistory } from "react-router-dom";

import PageShell from "components/PageShell";

import { Settings } from "constants/settings";

import AuctionPen from "containers/AuctionPenSale/AuctionPen";
import AuctionPenList from "containers/AuctionPenSale/AuctionPenList";

import { useMountEffect } from "hooks";

import {
  getLivestockSaleId,
  getSaleyardAuctionRoute,
  getSaleyardName,
} from "lib/navigation";

import { getAuctionPens, getSales, getSetting } from "selectors";

const AuctionPenPageShell = PageShell(AuctionPen);

const AuctionPenRoute = routeProps => (
  // Remount when the auction pen changes so the detail view refreshes its
  // pen-specific local state and derived values.
  <AuctionPenPageShell
    key={routeProps.match.params.auctionPenId}
    {...routeProps}
  />
);

const AuctionPenSale = () => {
  const history = useHistory();

  const hasAuctionPens = useSelector(
    state => Object.keys(getAuctionPens(state)).length !== 0,
  );
  const sales = useSelector(getSales);
  const round = useSelector(getSetting(Settings.round));

  useMountEffect(() => {
    const saleyard = getSaleyardName();
    const saleId = getLivestockSaleId();

    if (
      hasAuctionPens &&
      `${getSaleyardAuctionRoute(saleyard, saleId)}/firstround` ===
        history.location.pathname
    ) {
      const sale = sales[saleId];
      const { rounds } = sale;

      if (rounds) {
        const goToRound = rounds.includes(round) ? round : rounds[0];
        history.replace(getSaleyardAuctionRoute(saleyard, saleId, goToRound));
      }
    }
  });

  return (
    <Switch>
      <Route
        exact
        path={getSaleyardAuctionRoute(
          ":saleyard",
          ":saleId",
          ":roundId",
          ":auctionPenId",
        )}
        render={AuctionPenRoute}
      />
      <Route
        exact
        path={getSaleyardAuctionRoute(":saleyard", ":saleId", ":roundId")}
        component={AuctionPenList}
      />
    </Switch>
  );
};

export default AuctionPenSale;
